import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

// 获取所有房间的消息通知设置
export function getAllRoomNotify(args) {
  let url = BASE_API + '/chatroom/v2/settings/room/user/notify'
  return axiosGetHandler(url, args)
}

// 更新某个房间或者频道的消息通知设置
export function setNotify(args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/user_room/notify'
	return axiosPostHandler(url, args, formdata)
}

// 获取所有房间的未读消息数量
export function getAllUnreadState(args) {
  let url = BASE_API + '/chatroom/v2/msg/read_states'
  return axiosGetHandler(url, args)
}

/**
 * 更新未读计数
 * @description 如果需要清空所有，则直接传入all=true，如果清空房间则传房间id，如果清空分组则传group_id，如果清空频道则传channel_id
 * @param {*} args 
 * @param {*} formdata 
 * @param {string} formdata.channel_id 频道id
 * @param {string} formdata.group_id 分组id
 * @param {string} formdata.room_id 房间id
 * @param {boolean} formdata.all 是否清除所有
 * @returns 
 */
export function clearUnreadState(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/clear_read_states'
  return axiosPostHandler(url, args, formdata)
}

// 获取未读数量
export function getUnreadState(args) {
  let url = BASE_API + '/chatroom/v1/msg/channel_read_states'
  return axiosGetHandler(url, args)
}